import { atom, selector, useRecoilState } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";

const mapColorState = atom({
  key: 'mapColorState',
  default: selector({
    key: 'mapColorStateSelector',
    get: () => {
      return getCustomerSettings('mapConfig.MAP_COLOR');
    }
  })
});

export const useMapColorState = () => {
  const [mapColor, setMapColor] = useRecoilState(mapColorState);

  const isLightMap = mapColor === 'white';
  const isDarkMap = !isLightMap;

  const changeMapColorDark = ()=>{
    setMapColor('black');
  }
  const changeMapColorLight = () => {
    setMapColor('white');
  };

  return {
    mapColor,
    isLightMap,
    isDarkMap,
    changeMapColorDark,
    changeMapColorLight
  }
}